import httpCommerce from './httpCommerce'
import { getToken } from '@vue/services/jwt.service'

export const getProfile = async () => {
  return httpCommerce.get('/profile', {
    headers: {
      Authorization: `bearer ${await getToken()}`
    }
  })
}

export default {
  getProfile
}

